import type { PlatformUser } from '@/stores/auth'
import { useUser } from '@/stores/authStore'
import { useMemo } from 'react'

/**
 * The organization's uploaded brand mark, or null when it has none.
 *
 * Takes the organization id rather than reading it from the store, because callers disagree on
 * purpose: the switcher follows the URL so it never lags a redirect, while surfaces outside the
 * org routes follow `currentOrganizationId`.
 */
export function useOrgBrandMark(orgId: string | null): string | null {
	const user = useUser() as PlatformUser | null

	return useMemo(() => {
		const org = orgId ? user?.organizations?.find(o => o.id === orgId) : null
		return org?.frontend_settings?.branding?.brand_mark || null
	}, [user, orgId])
}
